/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const InformationOutline: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.92893 4.92893C8.83417 1.02369 15.1663 1.02369 19.0715 4.92893C22.9768 8.83417 22.9768 15.1663 19.0715 19.0715C15.1663 22.9768 8.83417 22.9768 4.92893 19.0715C1.02369 15.1663 1.02369 8.83417 4.92893 4.92893ZM17.6574 6.34299C14.5333 3.2188 9.46719 3.2188 6.34299 6.34299C3.2188 9.46719 3.2188 14.5333 6.34299 17.6574C9.46719 20.7816 14.5333 20.7816 17.6574 17.6574C20.7816 14.5333 20.7816 9.46719 17.6574 6.34299ZM11.0002 16.5002V12.5002C11.0002 11.9479 11.4479 11.5002 12.0002 11.5002C12.5525 11.5002 13.0002 11.9479 13.0002 12.5002V16.5002C13.0002 17.0525 12.5525 17.5002 12.0002 17.5002C11.4479 17.5002 11.0002 17.0525 11.0002 16.5002ZM12.0002 10.0002C12.8286 10.0002 13.5002 9.32865 13.5002 8.50022C13.5002 7.67179 12.8286 7.00022 12.0002 7.00022C11.1718 7.00022 10.5002 7.67179 10.5002 8.50022C10.5002 9.32865 11.1718 10.0002 12.0002 10.0002Z'
      fill='currentColor'
    />
  </React.Fragment>
)
